import styled from 'styled-components'

import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

export const TemplateRequestManagerStyled = styled.div`
  .title-container {
    padding: 30px 60px 0;
  }

  .create-process-container {
    padding: 24px 60px 40px;
  }

  /* Cabecera como la del resto de vistas: título 18/600 y descripción 14 en terciario */
  .description {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: ${tokens.color.text.tertiary};
  }

  /* Tarjetas de Velora (radio 6 y sombra suave), una por bloque, con su título 16/600 */
  .form-card {
    gap: 16px;
    padding: 24px;
    border-radius: 6px;
    background: ${tokens.color.background.default};
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
  }

  .form-card-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${tokens.color.text.primary};
  }

  .wrapper-general {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 40px;
  }

  .wrapper-short-block {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 35px;
    height: auto;
    border-radius: 25px;
    background: ${tokens.color.background.surface};
    box-shadow: ${tokens.shadow.card};
    margin-top: 30px;
  }

  .wrapper-large-block {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 35px;
    width: 100%;
    height: auto;
    border-radius: 25px;
    background: ${tokens.color.background.surface};
    box-shadow: ${tokens.shadow.card};
  }

  .title-create-process {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    color: ${tokens.color.text.primary};
    font-size: 20px; /* título de página de Velora (CommonHeaderGroup) */
    font-weight: 600;
  }

  .title-process {
    color: ${tokens.color.text.primary};
    font-size: 14px;
    font-weight: 500;
    &::after {
      content: '*';
      color: ${tokens.color.error.main};
      padding-left: 2px;
    }
  }
  /* 
  .label-picker {
    color: ${tokens.color.text.primary};
    font-size: 14px;
    font-weight: 400;

    &::after {
      content: '*';
      color: ${tokens.color.error.main};
      padding-left: 2px;
    }
  } */

  .container-item-text {
    min-width: 320px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .container-item-vacancies {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
  }

  .container-select {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 650px;
  }

  label {
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 0px;
    color: ${tokens.color.text.primary};

    &.required {
      ::after {
        content: '*';
        color: ${tokens.color.error.main};
        padding-left: 2px;
      }
    }
  }

  .group-input {
    label {
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 0px;

      &.required {
        ::after {
          content: '*';
          color: ${tokens.color.error.main};
          padding-left: 2px;
        }
      }
    }
    input {
      font-size: 14px;
      font-family: 'Poppins';
    }

    & h2 {
      font-size: 20px; /* título de página de Velora (CommonHeaderGroup) */
      font-weight: 600;
      color: ${tokens.color.text.primary};
      margin-bottom: 0;
    }
    & h5 {
      color: ${tokens.color.text.tertiary};
      font-weight: 400;
      margin-bottom: 0;
    }

    & p {
      font-weight: 400;
      color: ${tokens.color.text.tertiary};
    }
  }

  .headerTable {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 20px;

    h5 {
      margin-bottom: 0px;
    }
  }

  .containerButtons {
    display: inline-flex;
    align-items: center;
    align-self: end;
    justify-content: flex-end;
    gap: 10px;
    background-color: ${tokens.color.background.light};
    padding: 8px 10px;
    border-radius: 50px;
  }

  .autocomplete-custom-without-label {
    margin-top: 20px;
  }

  .textarea-question {
    min-height: 40px;
    background: ${tokens.color.background.default};
    border: 1px solid ${tokens.color.border.default};
    box-sizing: border-box;
    border-radius: 6px;
    padding: 9px 12px;
    font-family: ${tokens.typography.fontFamily.primary};
    font-weight: normal;
    font-size: 14px;
    color: ${colors.black};
    outline: none;
    resize: none;
    min-height: 100px;
    overflow-y: auto;

    ::placeholder {
      font-weight: normal;
      font-size: 14px;
      color: ${tokens.color.text.disabled};
    }

    width: 100% !important;
  }

  .container-questions {
    display: flex;
    flex-direction: column;
  }

  .wrapper-button {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }
  .button-custom {
    border-radius: 10px;
    color: ${tokens.color.text.onDark};
  }
`
